export default {
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  ON_SUCCESS_HOME_CITY_FETCH: 'ON_SUCCESS_HOME_CITY_FETCH',
  ON_SUCCESS_JOB_CITY_FETCH: 'ON_SUCCESS_JOB_CITY_FETCH',
  ON_SUCCESS_CITY_SEARCH: 'ON_SUCCESS_CITY_SEARCH',
  ON_SUCCESS_LOCALITY_FETCH: 'ON_SUCCESS_LOCALITY_FETCH',
};
